import { FormulaFilters } from '../../../lib/types/models/formula/formula'

export const transformFormulaFiltersToUrl = (filters?: FormulaFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.countries && filters.countries.length)
    searchParams.append('countries', filters.countries.join(','))

  return searchParams.toString()
}

export const transformUrlToFormulaFilters = (searchParams: URLSearchParams): FormulaFilters => {
  const filters: FormulaFilters = {}

  const countries = searchParams.get('countries')
  if (countries) filters.countries = countries.split(',').map((id) => +id)

  return filters
}
